import React, { useEffect, useState } from "react";
import { IonBadge, IonCard, IonCardContent, IonIcon, IonText } from "@ionic/react";
import { clipboardOutline } from "ionicons/icons";
import { useHistory } from "react-router";

import { GARNET } from "src/components/rutina/RutinaVista";
import RutinaAPI, { MiRutina } from "src/services/rutina";

/** Card del Home (operarios): resumen de la rutina de hoy. No pinta nada si no
 *  tiene rutina asignada o si falla la consulta. */
const MiRutinaCard: React.FC = () => {
  const [rutinas, setRutinas] = useState<MiRutina[]>([]);
  const history = useHistory();

  useEffect(() => {
    RutinaAPI.miRutina()
      .then((r) => setRutinas(r.data.datos.rutinas || []))
      .catch(() => setRutinas([]));
  }, []);

  if (rutinas.length === 0) return null;

  return (
    <div className="mt-1">
      {rutinas.map((r) => {
        const tareasHoy = r.sectores.flatMap((s) => s.tareas.filter((t) => t.hoy));
        const profundasHoy = tareasHoy.filter((t) => t.tipo === "PROFUNDA").length;
        return (
          <IonCard
            key={r.rutina_id}
            button
            onClick={() => history.push("/mi-rutina")}
            style={{ margin: "8px 0", borderLeft: `4px solid ${GARNET}` }}
          >
            <IonCardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <IonIcon icon={clipboardOutline} style={{ fontSize: 22, color: GARNET }} />
                <strong style={{ flex: 1, fontSize: 16 }}>Mi rutina de hoy</strong>
                {!r.aceptada_en && <IonBadge color="warning">Aceptar</IonBadge>}
              </div>
              <p style={{ margin: "6px 0 0" }}>
                {r.ps_nombre}
                {r.rol === "REEMPLAZO" ? ` · cubrís a ${r.titular_nombre}` : ""}
              </p>
              <IonText color="medium">
                <small>
                  {tareasHoy.length} tarea(s) hoy
                  {profundasHoy ? ` · ${profundasHoy} de limpieza profunda` : ""}
                </small>
              </IonText>
            </IonCardContent>
          </IonCard>
        );
      })}
    </div>
  );
};

export default MiRutinaCard;
